import { useSettings } from '~/@mid_settings/settings'
import { TopNavigation } from '~/@mid_ui/top-navigation/TopNavigation'
import { TopNavLink } from '~/@mid_ui/top-navigation/TopNavLink'

function AuthTopNavigation() {
  const { getLandingPageLink } = useSettings()
  return (
    <TopNavigation
      colorScheme="light"
      homeLinkPath="https://investinslovakia.eu">
      <div className="flex h-full">
        <div className="flex h-full gap-0 text-sm font-semibold">
          <TopNavLink
            to={getLandingPageLink('faq')}
            target="_blank"
            colorScheme="light">
            FAQ
          </TopNavLink>
        </div>
      </div>
    </TopNavigation>
  )
}

export { AuthTopNavigation }
